
import {
    apiModelModelApplyExampleDetail,
    apiModelModelApplyExampleEdit,
    apiModelModelApplyExampleAdd,
} from "@/api/model";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageMode } from "@/utils/type";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import Editor from "@/components/editor.vue";

@Component({
    components: {
        elImageViewer,
        Editor,
    },
})
export default class LogisticsEdit extends Vue {
    $refs!: {
        formRef: any;
    };

    categoryList = [
        {
            label: "全服类",
            value: 1,
        },
        {
            label: "烫画类",
            value: 2,
        },
        {
            label: "油画类",
            value: 3,
        },
    ];

    form: any = {
        title: "",
        category: 1,
        id: "",
        psd_images: {
            name: "psd_images",
            images: [],
        },
        face_images: {
            name: "face_images",
            images: [],
        },
        produce_images: {
            name: "produce_images",
            images: [],
        },
        db_images: {
            name: "db_images",
            images: [],
        },
        status: 1,
        content: "",
    };

    formData: any = [];
    engineList: any = [];
    temuEngineList: any = [];
    type = "";
    mode = "add";
    statusList: any = [];
    psd_images: any = [];
    face_images: any = [];
    db_images: any = [];
    produce_images: any = [];
    logList = [];
    formImages = [];
    imgViewerVisible = false;

    handleData: any = {
        images: [],
    };

    progressData: any = [];
    uploading = false;
    client: any = null;
    imgList: any = [];

    radioChange() {
        if (this.form.category === 1) {
            this.db_images = [];
        } else {
            this.produce_images = [];
        }
    }

    dialogColse() {
        this.progressData = [];
    }

    handlePreview($event: any, type: any) {
        console.log(this.form[type].images.map((v: any) => v.url));
        this.imgList = this.form[type].images.map((v: any) => v.url);
        this.imgViewerVisible = true;
    }

    async handleUpload(file: any, type: any) {
        // await apiShopFacImagesAdd({ auth: 1 })
        this.uploading = true;
        this.progressData.push({
            percentage: 0,
            name: file.file.name,
        });
        this.multipartUpload(
            file.file,
            `platform/model_template/${file.file.lastModified}/${file.file.name}`,
            this.progressData.length - 1,
            type
        );
    }

    async multipartUpload(file: any, filename: any, index: any, type: any) {
        await this.client.multipartUpload(filename, file, {
            progress: (percentage: any = 0, checkpoint: any) => {
                if (percentage) {
                    this.progressData[index].percentage = Math.round(
                        percentage * 100
                    );
                }
                if (percentage == 1) {
                    this.form[type].images.push({
                        name: file.name,
                        url: `https://fqsaas.oss-cn-shanghai.aliyuncs.com/${filename}`,
                    });
                    const count = this.progressData.filter(
                        (v: any) => v.percentage < 100
                    ).length;
                    if (count === 0) {
                        this.uploading = false;
                        this.progressData = [];
                    }
                    // this.uploading = false;
                }
            },
        });
    }

    handleRemove(e: any) {
        const index = this.handleData.images.findIndex((v: any) => {
            if (e.raw?.name) {
                return v.name === e.raw.name;
            } else {
                return v.name === e.name;
            }
        });
        this.handleData.images.splice(index, 1);
    }

    handleError() {}

    downLoad(item: any = []) {
        const domain = "https://fqsaas.oss-cn-shanghai.aliyuncs.com";
        const url = item.map((v: any) => {
            return v.url;
        });
        url.forEach((v: any) => {
            window.open(domain + v, "_blank");
        });
    }

    handleSave() {
        this.$refs.formRef.validate((valid: boolean): any => {
            if (!valid) {
                return;
            }
            if (this.mode == "edit") {
                apiModelModelApplyExampleEdit({
                    title: this.form.title,
                    status: this.form.status,
                    images: [
                        {
                            type: "psd_images",
                            images: this.form.psd_images.images,
                        },
                        {
                            type: "face_images",
                            images: this.form.face_images.images,
                        },
                        {
                            type: "db_images",
                            images: this.form.db_images.images,
                        },
                        {
                            type: "produce_images",
                            images: this.form.produce_images.images,
                        },
                    ],
                    content: this.form.content,
                    category: this.categoryList.filter(
                        (v) => v.value === this.form.category
                    )[0].label,
                    id: this.form.id,
                }).then((res) => {});
            } else {
                apiModelModelApplyExampleAdd({
                    status: this.form.status,
                    title: this.form.title,
                    images: [
                        {
                            type: "psd_images",
                            images: this.form.psd_images.images,
                        },
                        {
                            type: "face_images",
                            images: this.form.face_images.images,
                        },
                        {
                            type: "db_images",
                            images: this.form.db_images.images,
                        },
                        {
                            type: "produce_images",
                            images: this.form.produce_images.images,
                        },
                    ],
                    content: this.form.content,
                    category: this.categoryList.filter(
                        (v) => v.value === this.form.category
                    )[0].label,
                }).then((res) => {});
            }
        });
    }

    // 获取详情
    getDetail() {
        apiModelModelApplyExampleDetail({ id: this.form.id }).then((res) => {
            if (res.title) this.form.title = res.title;
            if (res.category) {
                this.form.category = this.categoryList.filter(
                    (v: any) => v.label === res.category
                )[0].value;
            }
            if (res.create_time) this.form.create_time = res.create_time;
            if (res.id) this.form.id = res.id;
            if (res.images) {
                res.images.forEach((v: any) => {
                    Object.keys(this.form).forEach((item: any) => {
                        if (v.type === item) {
                            console.log(v, item);
                            this.form[item].images = v.images;
                            // @ts-ignore
                            this[v.type] = v.images;
                        }
                    });
                });
            }
            if (res.spec) this.form.spec = res.spec;
            if (res.content) this.form.content = res.content;
            if (res.hasOwnProperty("status")) {
                this.form.status = res.status;
                this.form.status_ch = this.statusList.filter(
                    (v: any) => v.key === res.status
                )[0].value;
            }
        });
    }

    async created() {
        const query: any = this.$route.query;
        if (query.mode) this.mode = query.mode;

        if (this.mode === PageMode.EDIT) {
            this.form.id = query.id * 1;
            this.getDetail();
        }
    }

    mounted() {
        const OSS = require("ali-oss");
        // 初始化OSS客户端
        const ossConfig = {
            accessKeyId: "LTAI5tGVbBnU6raCDtfQSApi",
            accessKeySecret: "r7f1qmpwqvaS5z7ydNf4wXJfdNHqUT",
            bucket: "fqsaas",
            endpoint: "oss-cn-shanghai.aliyuncs.com",
            region: "oss-cn-shanghai",
            domain: "https://img.shopape.cn",
            ossdomain: "https://fqsaas.oss-cn-shanghai.aliyuncs.com",
        };
        this.client = new OSS(ossConfig);
    }
}
